import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=03e480d6&scoped=true&"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditions.vue?vue&type=style&index=0&id=03e480d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e480d6",
  null
  
)

export default component.exports